import MobileNumberVerificationModal from './MobileNumberVerificationModal';

const MobileVerificationWrapper = ({
  setIsMobileNumberVerified,
  showVerificationModal,
  setShowVerificationModal,
  mobileNumberToVerify,
}) => {
  return (
    <>
      {showVerificationModal && (
        <MobileNumberVerificationModal
          isOpen={showVerificationModal}
          onClose={() => setShowVerificationModal(false)}
          mobileNumber={mobileNumberToVerify}
          onVerificationSuccess={() => {
            setIsMobileNumberVerified(true);
          }}
        />
      )}
    </>
  );
};

export default MobileVerificationWrapper;
